import { atom, getDefaultStore } from 'jotai';

export type DictateReengagementTrigger = 'inline' | 'recording';

/** First completed in-app dictation this session. First write wins. */
export const dictateReengagementTriggerAtom = atom<DictateReengagementTrigger | null>(
  null
);

/** Dev-tools copy override; wins over {@link dictateReengagementTriggerAtom}. */
export const dictateReengagementDevTriggerOverrideAtom =
  atom<DictateReengagementTrigger | null>(null);

export const armDictateReengagementCard = (trigger: DictateReengagementTrigger): void => {
  const store = getDefaultStore();
  if (store.get(dictateReengagementTriggerAtom) !== null) return;
  store.set(dictateReengagementTriggerAtom, trigger);
};
